import { useAuth0 } from "@auth0/auth0-react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import React from "react";
import { Tip } from "../../components/Tip";

export function RemittanceComplete() {
  const { user } = useAuth0();
  const tip = user?.name ? ` Remittance sent by ${user.name}` : " Remittance sent";

  return (
    <Tip icon={<CheckCircleOutlineIcon color="primary" fontSize="large" />} title="Note added">
      <Typography fontWeight={600} color="primary">
        Don't forget to send the email!
      </Typography>
      <Box
        width="100%"
        textAlign="center"
        sx={{
          borderRadius: 1,
          backgroundColor: "grey.200",
          padding: 1,
        }}
      >
        <Typography fontWeight={600} component="span">
          TODAY
        </Typography>
        <Typography component="span">{tip}</Typography>
      </Box>
    </Tip>
  );
}
